import CTADownload from './CTADownload';
import CTASignUp from './CTASignUp';
import PropTypes from 'prop-types';
import React from 'react';

const CTASection = ({launched, info, appImage,cta, isSubscribed, isLoggedIn, ...props}) => {
    return (
        <div className="cta-section text-center">
        {launched ? (
            <CTADownload 
                country={info.countryCode} 
                link={info.iosLink} 
                image={appImage} />
        ) : (
            <CTASignUp 
                {...props} 
                ctaString={cta} 
                isSubscribed={isSubscribed}  
                isLoggedIn={isLoggedIn} />
        )}
        </div>
    );
};

CTASection.propTypes = {
    launched: PropTypes.bool,
    info: PropTypes.object,
    appImage: PropTypes.string,
    cta: PropTypes.string,
    isSubscribed: PropTypes.bool,
    isLoggedIn: PropTypes.bool

}

export default CTASection;
